var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCouponActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5C0 9.454 8.954.5 20 .5s20 8.954 20 20v20H20c-11.046 0-20-8.954-20-20z",
    fill: "#E9F7E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.348v-7.973c0-1.036.84-1.875 1.875-1.875h7.973c.498 0 .975.197 1.326.55l8.277 8.276c.732.732.732 1.92 0 2.651l-7.974 7.974a1.875 1.875 0 01-2.651 0l-8.277-8.277A1.875 1.875 0 0110 20.348zM14.375 13a1.875 1.875 0 100 3.75 1.875 1.875 0 000-3.75z",
    fill: "#25B000"
  })));
}

export default SvgCouponActive;